import { HowDidYouHearAboutUsOptionInput } from '../../lib/types/models/how-did-you-hear-about-us-option/how-did-you-hear-about-us-option-input'
import { UpdateInput } from '../../lib/types/utils'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function updateHowDidYouHearAboutUs(data: UpdateInput<HowDidYouHearAboutUsOptionInput>) {
  const { id, ...rest } = data
  return restApiClient
    .url(constructApiUrl(API.howDidYouHearAboutUs.update.url, { id }))
    .patch(rest)
}
